// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._o70ZbNPFTJnOPSCwL_0 {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
}

.xYZypM6cJi5nDCL2Wdg0 {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding-bottom: 8px;
  height: 92px;
}

.JyrpJ187UJwZUhRWEQWR {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.l07AM1PH2CNs9hLVhe7_ {
  width: 50%;
}

.Xv1FiC0jVDYsMbyrAH1f {
  overflow-y: auto;
  height: calc(100vh - 18rem);
}

.EXYD8snz8ByIrTd5fX8y {
  width: 100%;
  height: 50px;
  padding-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.Fu3ngWhzIDyoJlRg7tnM {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/screens/IdoAdministration/IdoAdministration.module.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AADJ;;AAIA;EACI,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,gBAAA;EACA,2BAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AADJ","sourcesContent":["\r\n\r\n.idoAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n}\r\n\r\n.idoFilterContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding-bottom: 8px;\r\n    height: 92px;\r\n}\r\n\r\n.idoSmallFilterInput {\r\n    width: 25%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.idoMediumFilterInput {\r\n    width: 50%;\r\n}\r\n\r\n.idoTableContainer {\r\n    overflow-y: auto;\r\n    height: calc(100vh - 18rem);\r\n}\r\n\r\n.idoTableFooter {\r\n    width: 100%;\r\n    height: 50px;\r\n    padding-top: 8px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.editIDOContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"idoAdminContainer": `_o70ZbNPFTJnOPSCwL_0`,
	"idoFilterContainer": `xYZypM6cJi5nDCL2Wdg0`,
	"idoSmallFilterInput": `JyrpJ187UJwZUhRWEQWR`,
	"idoMediumFilterInput": `l07AM1PH2CNs9hLVhe7_`,
	"idoTableContainer": `Xv1FiC0jVDYsMbyrAH1f`,
	"idoTableFooter": `EXYD8snz8ByIrTd5fX8y`,
	"editIDOContainer": `Fu3ngWhzIDyoJlRg7tnM`
};
export default ___CSS_LOADER_EXPORT___;
